// External libraries
import React from 'react';

// Internal modules
import { Footer, FooterLogo, FooterText } from './StyledComponents';

export type WalletsFooterProps = {
  connectedByLabel: string;
  ppwLogoUrl: string;
};

export const WalletsFooter = ({
  connectedByLabel,
  ppwLogoUrl,
}: WalletsFooterProps): React.ReactElement => (
  <Footer role="contentinfo">
    <FooterText>{connectedByLabel}</FooterText>
    <FooterLogo data-testid="wallets-list-ppw-logo" src={ppwLogoUrl} alt="" />
  </Footer>
);
